import { useState, useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setUpdateDialog,
  resetUpdateForm,
  OrderRechargeCards,
} from "../../../../app/slices/orderRechargeCardsSlice";
import { Controller, useForm } from "react-hook-form";
import { HiOutlinePencilSquare, HiOutlineHashtag } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";
const OrderRechargeCardNumberForm = ({ ids }) => {
  const [loading, setLoading] = useState(false);

  const _OrderrRechargeCard = useSelector(
    (state) => state.orderRechargeCards.orderRechargeCard
  );

  const { control, reset, handleSubmit } = useForm({
    defaultValues: _OrderrRechargeCard.form,
  });

  const onSubmit = (data) => {
    setLoading(true);
    data.ids = ids;
    dispatch(OrderRechargeCards.updateNumber(data))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    reset({ ..._OrderrRechargeCard.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_OrderrRechargeCard.form]);

  useEffect(() => {
    return () => {
      dispatch(resetUpdateForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handlDialog = () => {
    dispatch(setUpdateDialog());
  };

  return (
    <FormDialog
      open={_OrderrRechargeCard.dialog}
      onClose={() => {
        handlDialog();
      }}
      maxWidth="md"
      icon={<HiOutlinePencilSquare />}
      title="تحديث رقم الطلب"
      subtitle="أدخل رقم الطلب ثم احفظ التغييرات"
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
      loading={_OrderrRechargeCard.loading}
    >
      <SectionCard icon={<HiOutlineHashtag />} title="معلومات الطلب">
        <Grid item xs={12}>
          <Controller
            name="order_recharge_number"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="رقم الطلب"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default OrderRechargeCardNumberForm;
